import { render, staticRenderFns } from "./ZoneDelete.vue?vue&type=template&id=64766410&scoped=true"
import script from "./ZoneDelete.vue?vue&type=script&lang=js"
export * from "./ZoneDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64766410",
  null
  
)

export default component.exports